import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=16d2fe46&scoped=true"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"
import style0 from "./Drawer.vue?vue&type=style&index=0&id=16d2fe46&prod&lang=css"
import style1 from "./Drawer.vue?vue&type=style&index=1&id=16d2fe46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2fe46",
  null
  
)

export default component.exports